/**
 * 主题配置文件
 * 提供全局主题配置和主题切换功能
 */

import { ref, computed, watch } from 'vue';
import { useRouter } from 'vue-router';

// 默认主题配置
const defaultTheme = {
  // 主题模式: 'light' 或 'dark'
  mode: 'light',
  // 主色调
  primaryColor: '#1890ff',
  // 次要色调
  secondaryColor: '#52c41a',
  // 背景色
  backgroundColor: '#f0f2f5',
  // 文本颜色
  textColor: 'rgba(0, 0, 0, 0.85)',
  // 次要文本颜色
  secondaryTextColor: 'rgba(0, 0, 0, 0.45)',
  // 边框颜色
  borderColor: '#d9d9d9',
  // 卡片背景色
  cardBackgroundColor: '#ffffff',
  // 头部背景色
  headerBackgroundColor: '#ffffff',
  // 侧边栏背景色
  siderBackgroundColor: '#ffffff',
  // 菜单文本颜色
  menuTextColor: 'rgba(0, 0, 0, 0.85)',
  // 菜单激活文本颜色
  menuActiveTextColor: '#1890ff',
  // 表格头部背景色
  tableHeaderBackgroundColor: '#f7f7f7',
  // 表格内容背景色
  tableContentBackgroundColor: '#fcfcfc',
};

// 暗色主题配置
const darkTheme = {
  mode: 'dark',
  primaryColor: '#1890ff',
  secondaryColor: '#52c41a',
  backgroundColor: '#141414',
  textColor: 'rgba(255, 255, 255, 0.85)',
  secondaryTextColor: 'rgba(255, 255, 255, 0.45)',
  borderColor: '#434343',
  cardBackgroundColor: '#1f1f1f',
  headerBackgroundColor: '#1f1f1f',
  siderBackgroundColor: '#1f1f1f',
  menuTextColor: 'rgba(255, 255, 255, 0.85)',
  menuActiveTextColor: '#1890ff',
  tableHeaderBackgroundColor: '#1d1d1d',
  tableContentBackgroundColor: '#141414',
};

// 创建响应式主题状态
const currentTheme = ref(localStorage.getItem('theme') === 'dark' ? darkTheme : defaultTheme);

// 切换主题模式
const toggleTheme = () => {
  const newTheme = currentTheme.value.mode === 'light' ? darkTheme : defaultTheme;
  currentTheme.value = newTheme;
  localStorage.setItem('theme', newTheme.mode);
  applyTheme(newTheme);
};

// 应用主题到CSS变量
const applyTheme = (theme) => {
  const root = document.documentElement;
  
  // 设置CSS变量
  Object.entries(theme).forEach(([key, value]) => {
    // 将驼峰命名转换为CSS变量命名
    const cssVarName = '--' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
    root.style.setProperty(cssVarName, value);
  });
};

// 初始化主题
const initTheme = () => {
  applyTheme(currentTheme.value);
};

// 导出主题相关功能
export { 
  currentTheme, 
  toggleTheme, 
  initTheme,
  defaultTheme,
  darkTheme
};